import React, { FC, memo } from 'react'
import { Field } from 'formik'
import { IFacetItemProps } from '../types'
import { Spacing } from '../../Spacing/desktop'
import { Radio } from '../../Radio/desktop'
import { Checkbox } from '../../Checkbox/desktop'

/** Айтем фасета */
const FacetItem: FC<IFacetItemProps> = (props) => {
  const { name, controlName, value, isRadio, Icon, fontWeight } = props

  return (
    <>
      <Field
        as={isRadio ? Radio : Checkbox}
        name={controlName}
        type={isRadio ? 'radio' : 'checkbox'}
        value={String(value)}
        label={name}
        firstLetterUppercase
        submitOnChange
        key={value}
        Icon={Icon}
        fontWeight={fontWeight}
      />

      <Spacing spacing='large' />
    </>
  )
}

export default memo(FacetItem)
